import React, { useMemo } from 'react';
import MaterialTable from 'material-table';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import tableIcons from "./components/MaterialTableIcons";

const theme = createTheme({
  typography: { h6: { fontSize: '1.4em' } },
});

const PaymentID = (inputs) => {
  const columns = useMemo(() => [
    {
      title: 'CASE ID #',
      field: 'case_id',
      editable: 'never',
    },
    {
      title: 'Shipped Date',
      field: 'date_added',
      editable: 'never',
    },
    {
      title: 'Process ID #',
      field: 'process_id',
    },
    {
      title: 'AMT',
      field: 'job_amt',
      type: 'currency',
    },
  ], []);

  const tableData = useMemo(() => {
    return Array.isArray(inputs.data) ? inputs.data : [];
  }, [inputs.data]);

  const tableOptions = useMemo(() => ({
    sorting: true,
    search: false,
    searchFieldAlignment: "left",
    searchAutoFocus: false,
    searchFieldVariant: "outlined",

    filtering: false,
    paging: true,
    pageSizeOptions: [2, 5, 10, 15, 77],
    pageSize: 5,
    paginationType: "stepped",
    showFirstLastPageButtons: false,
    paginationPosition: "bottom",

    // ADDED: CSV export button for Microsoft Excel
    exportButton: {
      csv: true,
    },
    exportAllData: true,
    columnsButton: true,
    exportFileName: "Payable_Payment_Detail",

    addRowPosition: "first",
    actionsColumnIndex: -1,
    selection: false,
    showSelectAllCheckbox: false,
    showTextRowsSelected: false,
    grouping: false,

    rowStyle: (data, index) => index % 2 === 0 ? { background: "#f5f5f5" } : null,
    headerStyle: { background: "lightgray", fontStyle: "italic" },

    selectionProps: rowData => ({
      disabled: rowData.tax == null,
      color: "primary",
    }),
  }), []);

  return (
    <div className="App">
      <h1 align="center">Lento Accounts</h1>

      <ThemeProvider theme={theme}>
        <MaterialTable
          title={"Processor Name : " + inputs.name + "  Payment ID :" + inputs.id}
          icons={tableIcons}
          columns={columns}
          data={tableData}
          options={tableOptions}
        />
      </ThemeProvider>

      <h2>Total Amount : ${inputs.sum}</h2>
    </div>
  );
};

export default PaymentID;